mutation DeleteFailedEmails($input: DeleteFailedEmailsInput!) {
    failedEmailsDelete(input: $input) {
        numEmailsDeleted
        deleteDeferred
    }
}
